import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, Validators, NgControl } from '@angular/forms';
import { Warehouse, Warehouse1, Warehouse2, Warehouse3, Warehouse4, Warehouse5, Warehouse6 } from '../../warehouse';
import { Project } from '../../project';
import { SteelProfileService } from '../../../steel-profile/steel-profile.service';
import { isNullOrUndefined } from 'util';
import { WarehouseService } from '../../warehouse.service';
import { CINTAC_PURLIN_PROFILE } from '../../../steel-profile/steel-profile';


@Component({
  selector: 'app-secondary-elements',
  templateUrl: './secondary-elements.component.html',
  styleUrls: ['../project-form.css']
})
export class SecondaryElementsComponent implements OnInit {
  @Input() warehouse: Warehouse;
  secondaryElementsData: AbstractControl;
  purlinTypes = [];
  windColumnTypes = [];
  crossBracingEaveStructTypes = [];
  roofPurlinSupportConditions = []; // = Warehouse.getRoofPurlinSupportConditions(); // getRoofPurlinSupportConditionsWithoutC();
  roofPurlinCoveringType = Warehouse.getRoofPurlinCoveringType();
  purlinDict = {};
  windColumnDict = {};
  crossBracingEaveStructDict = {};
  hbProfileTypes = [];
  hbProfileDict = {};
  uf = {};
  max_sep = {};
  disable_roof_support_condition: boolean = false;

  formErrors = { wind_column_type: '',
                 cross_bracing_type_left: '',
                 cross_bracing_type_right: '',
                 eave_struct_type_shoulder: '',
                 eave_struct_type_roof: '',
                 front_purlin_type: '',
                 wall_purlin_type: '',
                 roof_purlin_type: '',
                 hb_front_type: '',
                 hb_lateral_type: '',
               };

  incompatibleProfileMsg = "No se encontró un perfil que se pueda usar para las restriciones del galpon. Utilice otro tipo de perfil o verifique las configuraciones del galpon";

  constructor(private fb: FormBuilder, private profileService: SteelProfileService,
    private warehouseService: WarehouseService
  ) {
    this.secondaryElementsData = this.fb.group({
      wind_column_type: ['', []],
      wind_column_profile: ['', []],
      wind_column_max_sep: ['', []],
      cross_bracing_type_left: ['', []],
      cross_bracing_type_right: ['', []],
      cross_bracing_left: ['', []],
      cross_bracing_right: ['', []],
      cross_bracing_max_empty_modules: ['', []],
      eave_struct_type_shoulder: ['', []],
      eave_struct_type_roof: ['', []],
      eave_struct_shoulder: ['', []],
      eave_struct_roof: ['', []],
      front_purlin_type: ['', []],
      front_purlin_profile: ['', []],
      front_purlin_max_sep: ['', []],
      front_purlin_hb_profile: ['', []],
      wall_purlin_type: ['', []],
      wall_purlin_profile: ['', []],
      wall_purlin_max_sep: ['', []],
      wall_purlin_hb_profile: ['', []],
      wall_purlin_hb_max_sep: ['', []],
      roof_purlin_type: ['', []],
      covering_type: ['', []],
      roof_support_condition: [{value:'', disabled: this.disable_roof_support_condition}],
      roof_purlin_profile: ['', []],
      roof_purlin_profile_extreme: ['', []],
      roof_purlin_max_sep: ['', []],
      hb_front_type: ['', []],
      hb_front_profile: ['', []],
      hb_lateral_type: ['', []],
      hb_lateral_profile: ['', []],

    });
  }

  ngOnInit() {
    this.profileService.getPurlins().subscribe((purlins) => {
      Object.keys(purlins).forEach((key) => {
        this.purlinTypes.push({ label: purlins[key].name, value: +key });
      });
      this.purlinDict = purlins;
    }
    );
    this.profileService.getCrossBracingsEaveStruct().subscribe((response) => {
      Object.keys(response).forEach((key) => {
        this.crossBracingEaveStructTypes.push({ label: response[key].name, value: +key });
      });
      this.crossBracingEaveStructDict = response;
    }
    );
    this.profileService.getWindColumns().subscribe((windColumns) => {
      Object.keys(windColumns).forEach((key) => {
        this.windColumnTypes.push({ label: windColumns[key].name, value: +key });
      });
      this.windColumnDict = windColumns;
    }
    );
    this.profileService.getCrossBracingsEaveStruct().subscribe((response) => {
      Object.keys(response).forEach((key) => {
        this.hbProfileTypes.push({ label: response[key].name, value: +key });
      });
      this.hbProfileDict = response;
    }
    );

    if(this.warehouse.roof_purlin_type == CINTAC_PURLIN_PROFILE){
      this.roofPurlinSupportConditions = Warehouse.getRoofPurlinSupportConditionsWithoutC()
    } else {
      this.roofPurlinSupportConditions = Warehouse.getRoofPurlinSupportConditions();
    }

    this.refresh();
    this.secondaryElementsData.valueChanges.subscribe(values => this.onValueChanged());
  }

  refresh(){
    this.secondaryElementsData.patchValue({
      wind_column_type: this.warehouse.wind_column_type,
      wind_column_profile: this.warehouse.wind_column_profile,
      wind_column_max_sep: this.warehouse.wind_column_max_sep,
      cross_bracing_type_left: this.warehouse.cross_bracing_type_left,
      cross_bracing_type_right: this.warehouse.cross_bracing_type_right,
      cross_bracing_left: this.warehouse.cross_bracing_left,
      cross_bracing_right: this.warehouse.cross_bracing_right,
      cross_bracing_max_empty_modules: this.warehouse.cross_bracing_max_empty_modules,
      eave_struct_type_shoulder: this.warehouse.eave_struct_type_shoulder,
      eave_struct_type_roof: this.warehouse.eave_struct_type_roof,
      eave_struct_shoulder: this.warehouse.eave_struct_shoulder,
      eave_struct_roof: this.warehouse.eave_struct_roof,
      front_purlin_type: this.warehouse.front_purlin_type,
      front_purlin_profile: this.warehouse.front_purlin_profile,
      front_purlin_max_sep: this.warehouse.front_purlin_max_sep,
      front_purlin_hb_profile: this.warehouse.front_purlin_hb_profile,
      wall_purlin_type: this.warehouse.wall_purlin_type,
      wall_purlin_profile: this.warehouse.wall_purlin_profile,
      wall_purlin_max_sep: this.warehouse.wall_purlin_max_sep,
      wall_purlin_hb_profile: this.warehouse.wall_purlin_hb_profile,
      wall_purlin_hb_max_sep: this.warehouse.wall_purlin_hb_max_sep,
      roof_purlin_type: this.warehouse.roof_purlin_type,
      covering_type: this.warehouse.covering_type,
      roof_support_condition: this.warehouse.roof_support_condition,
      roof_purlin_profile: this.warehouse.roof_purlin_profile,
      roof_purlin_profile_extreme: this.warehouse.roof_purlin_profile_extreme,
      roof_purlin_max_sep: this.warehouse.roof_purlin_max_sep,
      hb_front_type: this.warehouse.hb_front_type,
      hb_front_profile: this.warehouse.hb_front_profile,
      hb_lateral_type: this.warehouse.hb_lateral_type,
      hb_lateral_profile: this.warehouse.hb_lateral_profile,
    });
  }

  onValueChanged() {

    this.updateWarehouse();
    if(this.secondaryElementsData.value['roof_purlin_type'] == CINTAC_PURLIN_PROFILE){
      if(this.secondaryElementsData.value['roof_support_condition'] != 'sa'){
        this.secondaryElementsData.patchValue({
          roof_support_condition: 'sa'
        });
        this.warehouse.roof_support_condition = 'sa';
      }
      this.roofPurlinSupportConditions = Warehouse.getRoofPurlinSupportConditionsWithoutC();
    } else {
      this.roofPurlinSupportConditions = Warehouse.getRoofPurlinSupportConditions();
    }
    // this.warehouseFormService.updateFormMessages(this.loadsAndLiningsData, this.formErrors, this.validationMessages);
  }

  updateWarehouse() {
    const form = this.secondaryElementsData.value;
    this.warehouse.wind_column_type = form.wind_column_type;
    this.warehouse.wind_column_profile = form.wind_column_profile;
    this.warehouse.wind_column_max_sep = form.wind_column_max_sep;
    this.warehouse.cross_bracing_type_left = form.cross_bracing_type_left;
    this.warehouse.cross_bracing_type_right = form.cross_bracing_type_right;
    this.warehouse.cross_bracing_left = form.cross_bracing_left;
    this.warehouse.cross_bracing_right = form.cross_bracing_right;
    this.warehouse.cross_bracing_max_empty_modules = form.cross_bracing_max_empty_modules;
    this.warehouse.eave_struct_type_shoulder = form.eave_struct_type_shoulder;
    this.warehouse.eave_struct_type_roof = form.eave_struct_type_roof;
    this.warehouse.eave_struct_shoulder = form.eave_struct_shoulder;
    this.warehouse.eave_struct_roof = form.eave_struct_roof;
    this.warehouse.front_purlin_type = form.front_purlin_type;
    this.warehouse.front_purlin_profile = form.front_purlin_profile;
    this.warehouse.front_purlin_max_sep = form.front_purlin_max_sep;
    this.warehouse.front_purlin_hb_profile = form.front_purlin_hb_profile;
    this.warehouse.wall_purlin_type = form.wall_purlin_type;
    this.warehouse.wall_purlin_profile = form.wall_purlin_profile;
    this.warehouse.wall_purlin_max_sep = form.wall_purlin_max_sep;
    this.warehouse.wall_purlin_hb_profile = form.wall_purlin_hb_profile;
    this.warehouse.wall_purlin_hb_max_sep = form.wall_purlin_hb_max_sep;
    this.warehouse.covering_type = form.covering_type;
    this.warehouse.roof_support_condition = form.roof_support_condition;
    this.warehouse.roof_purlin_type = form.roof_purlin_type;
    this.warehouse.roof_purlin_profile = form.roof_purlin_profile;
    this.warehouse.roof_purlin_profile_extreme = form.roof_purlin_profile_extreme;
    this.warehouse.roof_purlin_max_sep = form.roof_purlin_max_sep;
    this.warehouse.hb_front_type = form.hb_front_type;
    this.warehouse.hb_front_profile = form.hb_front_profile;
    this.warehouse.hb_lateral_type = form.hb_lateral_type;
    this.warehouse.hb_lateral_profile = form.hb_lateral_profile;

  }

  calcul(context = null, funct = null) {
    console.log('calcul function');
    this.warehouseService.minorElements(this.warehouse.id).subscribe((data) => {
      this.warehouse.wind_column_type = data['front'] && data['front']['wind_column'] && data['front']['wind_column']['min_p'] && data['front']['wind_column']['min_p']['profile_type'];
      this.warehouse.wind_column_profile = data['front'] && data['front']['wind_column'] && data['front']['wind_column']['min_p'] && data['front']['wind_column']['min_p']['steelprofile_ptr'];
      this.warehouse.wind_column_max_sep = data['front'] && data['front']['wind_column'] && data['front']['wind_column']['max_sep'];
      this.warehouse.cross_bracing_type_left = data['struts'] && data['struts']['cross_bracing_left'] && data['struts']['cross_bracing_left']['profile_type'];
      this.warehouse.cross_bracing_type_right = data['struts'] && data['struts']['cross_bracing_right'] && data['struts']['cross_bracing_right']['profile_type'];
      this.warehouse.cross_bracing_left = data['struts'] && data['struts']['cross_bracing_left'] && data['struts']['cross_bracing_left']['steelprofile_ptr'];
      this.warehouse.cross_bracing_right = data['struts'] && data['struts']['cross_bracing_right'] && data['struts']['cross_bracing_right']['steelprofile_ptr'];
      this.warehouse.eave_struct_type_shoulder = data['struts'] && data['struts']['struct_shoulder'] && data['struts']['struct_shoulder']['profile_type'];
      this.warehouse.eave_struct_type_roof = data['struts'] && data['struts']['struct_roof'] && data['struts']['struct_roof']['profile_type'];
      this.warehouse.eave_struct_shoulder = data['struts'] && data['struts']['struct_shoulder'] && data['struts']['struct_shoulder']['steelprofile_ptr'];
      this.warehouse.eave_struct_roof = data['struts'] && data['struts']['struct_roof'] && data['struts']['struct_roof']['steelprofile_ptr'];
      this.warehouse.front_purlin_type = data['front'] && data['front']['purlins'] && data['front']['purlins']['wall'] && data['front']['purlins']['wall']['min_p'] && data['front']['purlins']['wall']['min_p']['profile_type'];
      this.warehouse.front_purlin_profile = data['front'] && data['front']['purlins'] && data['front']['purlins']['wall'] && data['front']['purlins']['wall']['min_p'] && data['front']['purlins']['wall']['min_p']['steelprofile_ptr'];
      this.warehouse.front_purlin_max_sep = data['front'] && data['front']['purlins'] && data['front']['purlins']['wall'] && data['front']['purlins']['wall']['real_sep'];
      this.warehouse.front_purlin_hb_profile = data['front'] && data['front']['purlins'] && data['front']['purlins']['hb'] && data['front']['purlins']['hb']['min_p'] && data['front']['purlins']['hb']['min_p']['steelprofile_ptr'];
      this.warehouse.wall_purlin_type = data['wall'] && data['wall']['min_p'] && data['wall']['min_p']['profile_type'];
      this.warehouse.wall_purlin_profile = data['wall'] && data['wall']['min_p'] && data['wall']['min_p']['steelprofile_ptr'];
      this.warehouse.wall_purlin_hb_profile = data['wall'] && data['wall']['hb'] && data['wall']['hb']['min_p'] && data['wall']['hb']['min_p']['steelprofile_ptr'];
      this.warehouse.wall_purlin_max_sep =  data['wall'] && data['wall']['real_sep'];
      this.warehouse.wall_purlin_hb_max_sep = data['wall'] && data['wall']['hb'] && data['wall']['hb']['real_sep'];
      this.warehouse.roof_purlin_type = data['roof'] && data['roof']['min_p'] && data['roof']['min_p']['profile_type'];
      this.warehouse.roof_purlin_profile = data['roof'] && data['roof']['min_p'] && data['roof']['min_p']['steelprofile_ptr'];
      this.warehouse.roof_purlin_profile_extreme = data['roof'] && data['roof']['ext_min_p'] && data['roof']['ext_min_p']['steelprofile_ptr'];
      this.warehouse.roof_purlin_max_sep = data['roof'] && data['roof']['real_sep'];
      this.warehouse.hb_front_type = data['hb'] && data['hb']['front'] && data['hb']['front']['profile'] && data['hb']['front']['profile']['profile_type'];
      this.warehouse.hb_front_profile = data['hb'] && data['hb']['front'] && data['hb']['front']['profile'] && data['hb']['front']['profile']['steelprofile_ptr'];
      this.warehouse.hb_lateral_type = data['hb'] && data['hb']['lateral'] && data['hb']['lateral']['profile'] && data['hb']['lateral']['profile']['profile_type'];
      this.warehouse.hb_lateral_profile = data['hb'] && data['hb']['lateral']['profile'] && data['hb']['lateral']['profile']['steelprofile_ptr'];
      this.uf['wind_column'] = data['front'] && data['front']['wind_column'] && data['front']['wind_column']['uf'];
      this.uf['front_purlin'] = data['front'] && data['front']['purlins'] && data['front']['purlins']['wall'] && data['front']['purlins']['wall']['uf'];
      this.uf['front_purlin_hb'] = data['front'] && data['front']['purlins'] && data['front']['purlins']['hb'] && data['front']['purlins']['hb']['uf'];
      this.uf['wall_purlin'] = data['wall'] && data['wall']['uf'];
      this.uf['wall_purlin_hb'] = data['wall'] && data['wall']['hb'] && data['wall']['hb']['uf'];
      this.uf['roof_purlin'] = data['roof'] && data['roof']['uf'];
      this.uf['ext_roof_purlin'] = data['roof'] && data['roof']['ext_uf'];

      this.max_sep['front_purlin_hb'] = data['front'] && data['front']['purlins'] && data['front']['purlins']['hb'] && data['front']['purlins']['hb']['real_sep'];

      this.formErrors.wind_column_type = (this.warehouse.wind_column_type == null) ? this.incompatibleProfileMsg : '';
      this.formErrors.cross_bracing_type_left = (this.warehouse.cross_bracing_type_left == null) ? this.incompatibleProfileMsg : '';
      this.formErrors.cross_bracing_type_right = (this.warehouse.cross_bracing_type_right == null) ? this.incompatibleProfileMsg : '';
      this.formErrors.eave_struct_type_shoulder = (this.warehouse.eave_struct_type_shoulder == null) ? this.incompatibleProfileMsg : '';
      this.formErrors.eave_struct_type_roof = (this.warehouse.eave_struct_type_roof == null) ? this.incompatibleProfileMsg : '';
      this.formErrors.front_purlin_type = (this.warehouse.front_purlin_type == null) ? this.incompatibleProfileMsg : '';
      this.formErrors.wall_purlin_type = (this.warehouse.wall_purlin_type == null) ? this.incompatibleProfileMsg : '';
      this.formErrors.roof_purlin_type = (this.warehouse.roof_purlin_type == null) ? this.incompatibleProfileMsg : '';
      this.formErrors.hb_front_type = (this.warehouse.hb_front_type == null) ? this.incompatibleProfileMsg : '';
      this.formErrors.hb_lateral_type = (this.warehouse.hb_lateral_type == null) ? this.incompatibleProfileMsg : '';


      this.refresh();
      if (context != null){
        funct.call(context, null);
        context.isCalculateSecondaryElements = true;
        context.finishCalculation();
      }


    }, (error) => {
      if (context != null){
        funct.call(context, null);
        context.finishCalculation();
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/project/project-form-components/secondary-elements/secondary-elements.component.ts